import { render, staticRenderFns } from "./recruitInfoPhone.vue?vue&type=template&id=bf9c77f8&scoped=true"
import script from "./recruitInfoPhone.vue?vue&type=script&lang=js"
export * from "./recruitInfoPhone.vue?vue&type=script&lang=js"
import style0 from "./recruitInfoPhone.vue?vue&type=style&index=0&id=bf9c77f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf9c77f8",
  null
  
)

export default component.exports